// https://stamps.atlassian.net/browse/WEBAPPS-30894
export default Object.freeze({
	All: 'all',
	Documents: 'documents',
	NonDocuments: 'non_documents',
});
